'use client'

/*
 * SPDX-FileCopyrightText: 2026 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */
import { Redirect } from '../../components/common/redirect'
import { HomePageContent } from '../../components/home-page/home-page-content'
import { useIsLoggedIn } from '../../hooks/common/use-is-logged-in'
import type { NextPage } from 'next'
import React from 'react'

/**
 * Renders the dashboard for logged-in users and redirects everyone else to the login page.
 */
const HomePage: NextPage = () => {
  const userLoggedIn = useIsLoggedIn()
  if (!userLoggedIn) {
    return <Redirect to={'/login'} replace={true} />
  }
  return <HomePageContent />
}

export default HomePage
